import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

interface UseMaintenanceEstablishmentChoiceManualEntryProposalEstablishmentAcceptProps {
  establishmentChoiceEntryId: string;
  options?: Partial<Omit<UseMutationOptions<unknown, ErrorResponse>, 'mutationKey' | 'mutationFn'>>;
}

export const useMaintenanceEstablishmentChoiceManualEntryProposalEstablishmentAccept = ({
  establishmentChoiceEntryId,
  options,
}: UseMaintenanceEstablishmentChoiceManualEntryProposalEstablishmentAcceptProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['maintenanceEstablishmentChoiceManualEntryProposalEstablishmentAccept'],
    mutationFn: () => {
      return privateAxios.put(`/maintenance/establishment_choice/manual_entry_proposals/${establishmentChoiceEntryId}/establishment_accept`);
    },
    ...options
  });
}
